import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5ecf1221"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "data-ingestion data-ingestion__skeleton" };
const _hoisted_2 = { class: "data-ingestion__header" };
const _hoisted_3 = { class: "data-ingestion__display" };
const _hoisted_4 = { class: "data-ingestion__alerts" };
import SkeletonLoader from '@/components/_atoms/SkeletonLoader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataIngestionTodayAlertsSkeleton',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(SkeletonLoader, {
                        height: "22px",
                        width: "140px"
                    }),
                    _createVNode(SkeletonLoader, {
                        height: "23px",
                        width: "85px"
                    })
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(SkeletonLoader, {
                        height: "15px",
                        width: "576px"
                    }),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(SkeletonLoader, {
                            height: "73px",
                            width: "626px"
                        })
                    ])
                ])
            ]));
        };
    }
});
